module.exports = __webpack_public_path__ + "img/violino-elettrico.9e7141d0.jpg";